import { render, staticRenderFns } from "./ChatSelectedMsg.vue?vue&type=template&id=2314ddae&scoped=true&lang=pug&"
import script from "./ChatSelectedMsg.vue?vue&type=script&lang=js&"
export * from "./ChatSelectedMsg.vue?vue&type=script&lang=js&"
import style0 from "./ChatSelectedMsg.vue?vue&type=style&index=0&id=2314ddae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2314ddae",
  null
  
)

export default component.exports